import { CategoricalCanvasLayout } from './CategoricalCanvasLayout.js';
import { CategoricalGridLayout } from './CategoricalGridLayout.js';
import { CategoricalGridZeroLineLayout } from './CategoricalGridZeroLineLayout.js';
import { CategoricalBarChartOverlaysBorder } from '../components/interactions/CategoricalBarChartOverlaysBorder.js';

export const CategoricalBarChartPlot = () => (
  <>
    <CategoricalGridLayout />
    <CategoricalCanvasLayout />
    <CategoricalGridZeroLineLayout />
    <CategoricalBarChartOverlaysBorder />
  </>
);

CategoricalBarChartPlot['displayName'] = 'CategoricalBarChartPlot';
